import React, { useRef, useState } from "react";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/custom/services/SharedService";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import {
    IconWrapper,
    ToggleIconWrapper,
} from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as FinanceListStyle from "../../../../../../common-deprecated/styles/v2/toyota/custom/FinanceList";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { BnbLabel } from "../../../utils/labels";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import MonthlyPrice from "../common/price/MonthlyPrice";
import { FINANCE_CALCULATOR, getDefaultPriceObject } from "../../../../../../common-deprecated/constants";
import FinanceInsuranceCalculatorLink from "../../../utils/FinanceInsuranceCalculatorLink";
import { setScrollToFinance } from "../../../../../../common-deprecated/redux/actions/UtilActions";
import useService from "../../../hooks/services/useService";
import { ServiceTypeEnum } from "../../../../../../common-deprecated/types/SettingsType";
import MonthlyRateDisclaimer from "../common/price/MonthlyRateDisclaimer";
import { getBnbMonthlyRateFormat } from "../../../utils/settings/bnbFinanceSettingUtils";
import FinanceQuotes from "../common/FinanceQuotes";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const FinanceService = (): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const priceFormat = useBnbSelector((state) =>
        getBnbMonthlyRateFormat(state.commonSettings, state.car.model ? state.car.model.internalCode : ""),
    );
    const total = useBnbSelector((state) => Number(state.finance.total));
    const financeInfo = useBnbSelector((state) => state.finance.info);
    const scrollHere = useBnbSelector((state) => state.utils.scrollToFinance);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);

    const data = useService(ServiceTypeEnum.Finance);
    const quoteTable = financeInfo.disclaimer?.table;
    const [isOpen, setIsOpen] = useState(true);
    const togglerLabel = isOpen ? "showLess" : "showMore";
    const element = useRef<HTMLDivElement>(null);

    if (scrollHere && element.current) {
        element.current.scrollIntoView({ behavior: "smooth" });
        dispatch(setScrollToFinance(false));
    }

    if (!data) return null;
    const { title, description, bannerLinkImage } = data;

    return (
        <Styles.ServiceWrapper ref={element}>
            {bannerLinkImage && (
                <Styles.Banner>
                    <Styles.Image src={`${bannerLinkImage}`} height={170} />
                </Styles.Banner>
            )}

            <Styles.Title>{title ? <span>{title}</span> : <BnbLabel label="basketFinancePlan" />}</Styles.Title>

            {description && <Styles.Description dangerouslySetInnerHTML={{ __html: data.description! }} />}

            {financeOption !== "monthly" ? (
                <Flex.Row justifyContent="flex-end">
                    <Flex.Col>
                        <FinanceInsuranceCalculatorLink
                            type={FINANCE_CALCULATOR}
                            customButton={(props) => (
                                <Button.Checkbox type="button" onClick={() => props.onClick()}>
                                    <IconWrapper>
                                        <Icon variant="plus" />
                                    </IconWrapper>
                                </Button.Checkbox>
                            )}
                        />
                    </Flex.Col>
                </Flex.Row>
            ) : (
                <>
                    <Flex.Row>
                        <Flex.Col width={1 / 2}>
                            <Styles.MonthlyPriceWrapper>
                                <MonthlyPrice
                                    price={{ ...getDefaultPriceObject(), monthly: total }}
                                    priceFormat={priceFormat}
                                    financeInfo={financeInfo}
                                    forceHideDisclaimer
                                />
                            </Styles.MonthlyPriceWrapper>
                        </Flex.Col>
                        <Flex.Col width={1 / 2} display="flex" justifyContent="flex-end" alignItems="flex-end">
                            <FinanceInsuranceCalculatorLink
                                type={FINANCE_CALCULATOR}
                                customButton={(props) => (
                                    <Button.Checkbox type="button" onClick={() => props.onClick()}>
                                        <IconWrapper>
                                            <Icon variant="plus" />
                                        </IconWrapper>
                                    </Button.Checkbox>
                                )}
                            />
                        </Flex.Col>
                    </Flex.Row>

                    {quoteTable && (
                        <>
                            {isOpen && (
                                <Styles.ListWrapper>
                                    <FinanceQuotes />
                                    <FinanceListStyle.Footer>
                                        <MonthlyRateDisclaimer
                                            price={{ ...getDefaultPriceObject(), monthly: total }}
                                            priceFormat={priceFormat}
                                            financeInfo={financeInfo}
                                        />
                                    </FinanceListStyle.Footer>
                                </Styles.ListWrapper>
                            )}

                            <Styles.Toggle onClick={() => setIsOpen(!isOpen)}>
                                <Flex.Row>
                                    <Flex.Col width={1 / 2} display="flex" alignItems="center">
                                        <Styles.ToggleText>
                                            <BnbLabel label={togglerLabel} />
                                        </Styles.ToggleText>
                                        <ToggleIconWrapper isDown={isOpen} m={1}>
                                            <Icon variant="chevronDown" />
                                        </ToggleIconWrapper>
                                    </Flex.Col>
                                    <Flex.Col width={1 / 2} display="flex" justifyContent="flex-end">
                                        <FinanceInsuranceCalculatorLink
                                            type={FINANCE_CALCULATOR}
                                            customButton={(props) => (
                                                <Button.Checkbox selected onClick={() => props.onClick()}>
                                                    <IconWrapper>
                                                        <Icon variant="close" />
                                                    </IconWrapper>
                                                </Button.Checkbox>
                                            )}
                                        />
                                    </Flex.Col>
                                </Flex.Row>
                            </Styles.Toggle>
                        </>
                    )}
                </>
            )}
        </Styles.ServiceWrapper>
    );
};

export default FinanceService;
